import { Device } from './device';
import { sha256 } from 'js-sha256';

const form_scores = [
    { name: 'custom_lead_source__c', options: ['Website - Quote'], value: 11 },
    { name: 'custom_lead_source__c', options: ['Website - Download', 'Website - Contact'], value: -8.75 },
    { name: 'ib_shipments_per_month_picklist', options: ['401 - 1,000', '1,001 - 5,000', '5,001 - 10,000', '10,000+'], value: 35 },
    { name: 'ib_shipments_per_month_picklist', options: ['201 - 400', '1 - 200'], value: 10.5 },
];

const EmailScore = async (email = '') => {
    const email_blacklist = new RegExp(/(yahoo|gmail|outlook|hotmail|aol|icloud|att|me\.com)/);
    const blacklisted = email.match(email_blacklist)
    if (blacklisted !== null) {
        return 0;
    } else {
        return 24;
    }
};

const DeviceScore = async () => {
    const device = Device();

    if (device == 'Computer') {
        return 15;
    } else {
        return 0;
    }
}

const CountryScore = async () => {
    const a_country_codes = [ 'AU', 'CA', 'DK', 'DE', 'IE', 'NZ', 'PT', 'GB', 'US', 'NL', 'FR' ];
    const b_country_codes = [ 'BR', 'ID', 'IL', 'LT', 'MX', 'SE', 'CH', 'TH' ];

    if (!window.multisite_info || !window.multisite_info.country) {
        return 0;
    }

    const country = window.multisite_info.country;

    switch(true) {
        case a_country_codes.includes(country):
            return 15;
        case b_country_codes.includes(country):
            return 9.75;
        default:
            return 0;
    }
}

const FormScores = async (formDataObject) => {
    return form_scores.reduce((total, current) => {
        const value = formDataObject[current.name];
        if (current.options.includes(value)) {
            return current.value + total;
        } else {
            return total;
        }
    }, 0);
}

export const LeadScore = async (formDataObject) => {
    const form_score = await FormScores(formDataObject);
    const email_score = await EmailScore(formDataObject.email);
    const country_score = await CountryScore();
    const device_score =  await DeviceScore();

    const score = form_score + email_score + country_score + device_score;

    switch(true) {
        case score >= 80:
            return { lead_score: score, lead_quality: 'A' };
        case score < 80 && score > 64.5:
            return { lead_score: score, lead_quality: 'B' };
        case score <= 64.5 && score >= 51:
            return { lead_score: score, lead_quality: 'C' };
        default:
            return { lead_score: score, lead_quality: 'D' };
    }
};

export const SubmitGAEvent = async (results) => {
    if (typeof gtag === 'undefined' || !gtag) {
        return results;
    }

    gtag('event', `lead_score_${results.lead_quality}`, { 'page': window.location.href });
    return results;
};

export const ReturnLeadScore = async (results) => {
    return results;
}

export const AdvancedConversions = async (formData) => {
    const email = formData.email;

    if (!email) {
        return formData
    }

    const hashed_email = sha256.hex(email);

    dataLayer.push({
        event: 'ADVANCED_CONVERSION',
        user_data: {
            email: hashed_email,
        },
    });
    
    return formData;
}

export const PartnerStackConfiguration = async (formData) => {
    if (typeof growsumo === 'undefined' || !growsumo) {
        return formData;
    }
    
    const {
        email,
        firstname,
        lastname,
    } = formData;

    const name = `${firstname} ${lastname}`;

    growsumo.data.email = email;
    growsumo.data.name = name;
    growsumo.data.customer_key = email;
    growsumo.createSignup();
    
    return formData;
}

export const CalculateLeadScore = async (form_element) => {
    const formData = new FormData(form_element);

    return await AdvancedConversions(Object.fromEntries(formData.entries()))
        .then((formData) => PartnerStackConfiguration(formData))
        .catch((err) => console.error(err));
}